import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import {
    Link
} from "react-router-dom";
export default function Notification() {
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const [showLogoutButton, setShowLogoutButton] = useState(false);
    const menuRef = useRef(null);
    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target) && !document.getElementById("notification_icon").contains(event.target)) {
                setProfileMenuOpen(false); // Close the menu if clicked outside
            }
        };

        if (profileMenuOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [profileMenuOpen]);
    return (
        <div>
            <button onClick={()=>setProfileMenuOpen(!profileMenuOpen)} id="notification_icon" type="button" class="text-gray-500 relative inline-flex items-center cursor-pointer mr-4 p-2 rounded-full hover:text-blue-600 hover:bg-gray-200">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="0" y="0" width="24" height="24" stroke="none"></rect>
                    <path d="M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6" />
                    <path d="M9 17v1a3 3 0 0 0 6 0v-1" />
                </svg>
                <span class="sr-only">Notifications</span>
                {/* <div class="absolute inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-red-500 border-1 border-white rounded-full -top-0.5 -end-[0px] dark:border-gray-900">1</div> */}
                <div class="absolute inline-flex items-center justify-center w-2 h-2 text-[10px] font-bold text-white bg-red-500 border-1 border-white rounded-full top-[4px] right-[10px] dark:border-gray-900"></div>
            </button>
            {profileMenuOpen && (
                <>
                <div className="fixed p-3 w-full top-4 mt-12 right-0 sm:w-96 z-40">
                    <div ref={menuRef} id="toast-notification" class="p-3 text-gray-900 bg-white rounded-lg shadow w-full" role="alert">
                        <div class="flex items-center mb-2">
                            <span class="text-sm font-semibold text-gray-900 ">New notification</span>
                            <button onClick={()=>setProfileMenuOpen(false)} type="button" class="ms-auto -mx-1.5 -my-1.5 bg-white justify-center items-center flex-shrink-0 text-gray-400 hover:text-gray-900 rounded-lg focus:ring-2 focus:ring-gray-300 p-1.5 hover:bg-gray-100 inline-flex h-8 w-8" data-dismiss-target="#toast-notification" aria-label="Close">
                                <span class="sr-only">Close</span>
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                            </button>
                        </div>
                        <Link to={"/notifications"} onClick={()=>setProfileMenuOpen(false)} class="flex items-center my-1 hover:bg-slate-100 p-1 rounded-lg ">
                            <div class="relative inline-block shrink-0">
                                <img class="w-12 h-12 rounded-full" src="/img/logo192.png" alt="Jese Leos image" />
                            </div>
                            <div class="ms-3 text-sm font-normal">
                                <div class="text-sm font-semibold text-gray-900">Nexus</div>
                                <div class="text-sm font-normal">Notifications window launched</div>
                                {/* <span class="text-xs font-medium text-blue-600 dark:text-blue-500">a few seconds ago</span> */}
                            </div>
                        </Link>
                        <Link to={"/results"} onClick={()=>setProfileMenuOpen(false)} class="flex items-center my-1 hover:bg-slate-100 p-1 rounded-lg ">
                            <div class="relative inline-block shrink-0">
                                <img class="w-12 h-12 rounded-full" src="/img/logo192.png" alt="Jese Leos image" />
                            </div>
                            <div class="ms-3 text-sm font-normal">
                                <div class="text-sm font-semibold text-gray-900">Nexus</div>
                                <div class="text-sm font-normal">Result window launched</div>
                                {/* <span class="text-xs font-medium text-blue-600 dark:text-blue-500">a few seconds ago</span> */}
                            </div>
                        </Link>
                    </div>
                    </div>
                </>
            )}
        </div>
    )
}
